var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoShortlist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 209,
    height: 200
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "no_shortlist_svg__a",
    x: 57,
    y: 46,
    width: 112,
    height: 123,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2039d1",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no_shortlist_svg__b",
    x: 37,
    y: 38,
    width: 124,
    height: 141,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2039d1",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no_shortlist_svg__c",
    x: 30.003,
    y: 37.999,
    width: 119,
    height: 150,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2039d1",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 255",
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#b47df4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5276"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5275"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#no_shortlist_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1945",
    width: 76,
    height: 87,
    rx: 6,
    transform: "translate(75 58)",
    fill: "#c8d5ff"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#no_shortlist_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2404",
    width: 88,
    height: 105,
    rx: 6,
    transform: "translate(55 50)",
    fill: "#c8d5ff"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6455"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.003 -.001)",
    filter: "url(#no_shortlist_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1945",
    width: 89,
    height: 120,
    rx: 6,
    transform: "translate(45 43)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5271",
    transform: "translate(59.034 133.307)",
    fill: "#0d2976"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1904",
    width: 61,
    height: 6,
    rx: 2,
    transform: "translate(-.034 -.307)",
    opacity: 0.102
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1905",
    width: 38,
    height: 5,
    rx: 2,
    transform: "translate(11.966 8.693)",
    opacity: 0.102
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5277"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1858",
    width: 56,
    height: 18,
    rx: 9,
    transform: "translate(61 56.001)",
    fill: "#f6fba9"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 10",
    transform: "translate(69.831 81.388)",
    clipPath: "url(#no_shortlist_svg__d)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5370",
    transform: "translate(-.023 .483)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2021",
    width: 38,
    height: 38,
    rx: 19,
    transform: "translate(.192 .129)",
    fill: "#4b75ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 956",
    d: "M15.817 22.785h7.925s-.957 4.2 0 6.379-8.822 1.544-7.925 0 0-6.379 0-6.379z",
    fill: "#d39f2a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 957",
    d: "M19.988 14.435c4.079.142 4.12 1.798 4.12 4.02v2.672c0 2.218-2.807 4.016-4.121 4.016s-4.12-1.798-4.12-4.016v-2.672c0-2.222.043-4.163 4.121-4.02z",
    fill: "#0d2976",
    opacity: 0.186
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 958",
    d: "M16.101 26.678c.272.1 2.192 1.541 4.119 1.514a5.515 5.515 0 003.039-1.514c8.388 1.571 10.215 3.447 10.215 5.761v4.714a4.136 4.136 0 01-4.079 4.19H10.529a4.136 4.136 0 01-4.079-4.19s-.1-2.543 0-4.714 2.5-3.778 9.651-5.761z",
    fill: "#eef755"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5369"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5368",
    transform: "translate(11.917 6.232)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2022",
    width: 1.938,
    height: 5.33,
    rx: 0.969,
    transform: "rotate(-6.024 74.899 3.941)",
    fill: "#d39f2a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 959",
    d: "M8.071.014C14.828.272 14.9 3.268 14.9 7.282v4.846c0 4.014-4.652 7.268-6.829 7.268s-6.829-3.256-6.829-7.268V7.281c0-4.013.071-7.526 6.829-7.267z",
    fill: "#d39f2a"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2023",
    width: 1.938,
    height: 5.33,
    rx: 0.969,
    transform: "rotate(6.024 -65.863 138.908)",
    fill: "#d39f2a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 21",
    d: "M8.071 19.394h-.006V.013h.006c3.118.119 5.008.827 5.949 2.226.88 1.309.88 3.123.88 5.042v4.845a7.341 7.341 0 01-2.6 5.139 9.876 9.876 0 01-2.244 1.558 4.792 4.792 0 01-1.985.571z",
    fill: "#be8d21"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 23",
    d: "M13.153 16.023v-2.51c0-1.833 0-3.729.793-5.093a3.8 3.8 0 011.828-1.595 8.753 8.753 0 013.526-.593c.219 0 .449 0 .681.013 3.118.119 5.008.826 5.948 2.226.88 1.309.88 3.123.88 5.042v1.229c-.549-.047-1.81-.18-4.091-.537a12.628 12.628 0 01-4.33-1.638 15.278 15.278 0 01-1.85-1.249l-.378.74c0-.006-.284-.639-.576-.639a.291.291 0 00-.232.156 1.56 1.56 0 00-.2.812 5.363 5.363 0 01-.427 1.818 3.011 3.011 0 01-1.572 1.817z",
    fill: "#0d2976"
  })))))))));
}
export default SvgNoShortlist;